import { render } from "./IframePage.vue?vue&type=template&id=0cabe728"
import script from "./IframePage.vue?vue&type=script&lang=js"
export * from "./IframePage.vue?vue&type=script&lang=js"

import "./IframePage.vue?vue&type=style&index=0&id=0cabe728&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__